module.exports = __webpack_public_path__ + "images/referenzen/werbespot/barclays_tvc.jpg";